import { format } from 'date-fns'
import dayjs from 'dayjs'

import { parseCurrency } from '@helper/parseCurrency'

import { toLocaleString, toLocaleString4 } from './strings'

export const parseParametrizationSupplyData = (data: any[]): any[] => {
  const res = []
  for (const item of data) {
    res.push({
      'id-id': item.idEstoque,
      'estoque-endereco': item.estoqueEndereco ? item.estoqueEndereco : '',
      'estoque-ultima-venda-empresa': item.estoqueUltimaVendaEmpresa
        ? dayjs(item.estoqueUltimaVendaEmpresa).format('DD/MM/YYYY ') // verificar
        : '',
      'estoque-ultima-venda-loja': item.estoqueUltimaVendaLoja
        ? dayjs(item.estoqueUltimaVendaLoja).format('DD/MM/YYYY') // verificar
        : '',
      'estoque-atual': parseCurrency({
        value: item.estoqueEstoqueAtual,
        country: 'pt-br',
        minFraction: 0
      }),
      'estoque-deposito-16': parseCurrency({
        value: item.estoqueEstoqueDeposito16,
        country: 'pt-br',
        minFraction: 0
      }),
      'produto-categoria-compacta':
        item.categoriaCompactaDescricao.toUpperCase(),
      'produto-sub-categoria': item.subCategoriaDescricao.toUpperCase(),
      // API omite a chave quando o produto nao tem marca/essencia
      'produto-marca': item.produtoMarca ?? '',
      'produto-essencia': item.produtoEssencia ?? '',
      'produto-mundo': item.mundoDescricao.toUpperCase(),
      'estoque-transito': parseCurrency({
        value: item.estoqueEstoqueTransito,
        country: 'pt-br',
        minFraction: 0
      }),
      'dias-venda-retira': item.diasdeVendaRetiraCentro4M
        ? parseCurrency({
            value: item.diasdeVendaRetiraCentro4M,
            country: 'pt-br',
            minFraction: 0
          })
        : 0, // VERIFICAR
      'dias-venda-total': item.diasdeVendaTotalCentro4M
        ? parseCurrency({
            value: item.diasdeVendaTotalCentro4M,
            country: 'pt-br',
            minFraction: 0
          })
        : 0, // VERIFICAR
      'venda-media-retira': item.vendaMediaRetiraCentro4M
        ? toLocaleString4(item.vendaMediaRetiraCentro4M)
        : 0,
      'venda-media-total': item.vendaMediaTotalCentro4M
        ? toLocaleString4(item.vendaMediaTotalCentro4M)
        : 0,

      'cd-origem-nome': item.cdOrigemNome ? item.cdOrigemNome : '',
      'cd-origem-codigo': item.cdOrigemCodigo ? item.cdOrigemCodigo : '',
      'fornecedor-nome': item.fornecedorNome ? item.fornecedorNome : '',
      'fornecedor-codigo': item.fornecedorCodigo ? item.fornecedorCodigo : '',
      'fornecedor-codigo-produto': item.codigoFornecedorProduto
        ? item.codigoFornecedorProduto
        : '',
      'politica-utilizar-otimizada':
        item.politicaEstoqueSegurancaUtilizarOtimizada != null
          ? item.politicaEstoqueSegurancaUtilizarOtimizada
            ? 'Sim'
            : 'Não'
          : null,
      'politica-otimizada': parseCurrency({
        value: item.politicaEstoqueSegurancaOtimizada,
        country: 'pt-br',
        minFraction: 0
      }),
      'politica-arbritada': parseCurrency({
        value: item.politicaEstoqueSegurancaArbitrada,
        country: 'pt-br',
        minFraction: 0
      }),
      'parametros-ponto-pedido-dias': item.pontoPedidoDias,
      'parametros-tipo-suprimentos': item.parametrosTipoSuprimento,
      'parametros-estoque-arbritado': parseCurrency({
        value: item.parametrosEstoqueArbitrado,
        country: 'pt-br',
        minFraction: 0
      }),
      'parametros-lote-multiplo': parseCurrency({
        value: item.parametrosLoteMutiplo,
        country: 'pt-br',
        minFraction: 0
      }),
      'parametros-estoque-minimo': parseCurrency({
        value: item.estoqueMinimo || 0,
        country: 'pt-br',
        minFraction: 0
      }),
      'parametros-utilizar-estoque-minimo': item.utilizarEstoqueMinimo
        ? 'Sim'
        : 'Nao',
      'parametros-lote-minimo-cd': parseCurrency({
        value: item.parametrosLoteMinimoCD,
        country: 'pt-br',
        minFraction: 0
      }),
      'parametros-frequencia-pedidos': parseCurrency({
        value: item.parametrosFrequenciaPedidos,
        country: 'pt-br',
        minFraction: 0
      }),
      'parametros-previsao-lead-time':
        item.parametrosPrevisaoLeadTime != null
          ? item.parametrosPrevisaoLeadTime
            ? 'Sim'
            : 'Não'
          : null,
      'parametros-utilizar-ponto-pedido':
        item.utilizarPontoPedido != null
          ? item.utilizarPontoPedido
            ? 'Sim'
            : 'Não'
          : null,
      'parametros-lead-time': parseCurrency({
        value: item.parametrosLeadTime,
        country: 'pt-br',
        minFraction: 0
      }),
      'parametros-emax': parseCurrency({
        value: item.parametrosEmax,
        country: 'pt-br',
        minFraction: 0
      }),
      'parametros-abastecer':
        item.parametrosAbastecer != null
          ? item.parametrosAbastecer
            ? 'Sim'
            : 'Não'
          : null,
      'produto-grupo-separacao': item.produtoGrupoSeparacao
        ? item.produtoGrupoSeparacao
        : '',
      'produto-curva-abc-empresa': item.produtoCurvaABCEmpresa
        ? item.produtoCurvaABCEmpresa
        : '',
      'produto-curva-abc':
        item.produtoCurvaABC !== null ? item.produtoCurvaABC : '',
      'produto-status': item.produtoStatus !== null ? item.produtoStatus : '',
      'produto-nome': item.produtoNome !== null ? item.produtoNome : '',
      'produto-id': item.produtoCodigo !== null ? item.produtoCodigo : '',
      'centro-codigo': item.centroCodigo !== null ? item.centroCodigo : '',
      'centro-id': item.centroNome ? item.centroNome : '',
      'parametros-cluster-centro':
        item.clusterCentro !== null ? item.clusterCentro : '',
      'parametros-cluster-produto':
        item.clusterProduto !== null ? item.clusterProduto : '',
      'estoque-cd': item.estoqueCD !== null ? item.estoqueCD : '',
      'estoque-peso-unit': toLocaleString(item.pesoUnitarioProduto),
      'estoque-custo-unit': toLocaleString(item.custoUnitarioProduto),
      'estoque-cmm': toLocaleString(item.cmm),
      'produto-gerente-categoria': item.gerenteCategoriaDescricao,
      'gerente-produto-id': item.gerenteProdutoId,
      'gerente-produto-desc': item.gerenteProdutoDescricao,
      'estoque-sortimento':
        item.estoqueSortimento != null
          ? item.estoqueSortimento
            ? 'Sim'
            : 'Não'
          : null,
      'estoque-primeira-entrada': item.primeiraEntradaDoProduto
        ? dayjs(item.primeiraEntradaDoProduto.split('T')[0]).format(
            'DD/MM/YYYY'
          )
        : '-',
      'ruptura-zero-dias':
        item.rupturaZeroDias != null
          ? item.rupturaZeroDias
            ? 'Sim'
            : 'Não'
          : '-',
      'ruptura-dez-dias':
        item.rupturaDezDias != null
          ? item.rupturaDezDias
            ? 'Sim'
            : 'Não'
          : '-'
    })
  }

  return res
}

export const parseParametrizatioRevisionData = (data: any[]): any[] => {
  const res = []
  for (const item of data) {
    res.push({
      'id-id': item.id,
      'solicitacao-solicitante': item.requisitor.nome,
      'solicitacao-data': dayjs(item.data).format('DD-MM-YYYY'),
      'valor-antigo': item.valorAntigo,
      'valor-novo': item.valorNovo,
      'produto-codigo': item.produto.id,
      'produto-descricao': item.produto.descricao,
      'loja-codigo': item.loja.id,
      'loja-descricao': item.loja.descricao,
      'aprovacao-nome': item.revisor ? item.revisor.nome : '',
      'aprovacao-data': item.revisao
        ? dayjs(item.revisao).format('DD-MM-YYYY')
        : '',
      'aprovacao-status': item.status
    })
  }

  return res
}

export const parseParametrizatioProductSimilarData = (data: any[]): any[] => {
  const res = []
  for (const item of data) {
    res.push({
      'id-id': item.id,
      'empresa-id': item.idEmpresa,
      'empresa-nome': item.empresa.descricao,
      'produto-novo-id': item.produto.id,
      'produto-novo-nome': item.produto.descricao,
      'produto-similar-id': item.similar.id,
      'produto-similar-nome': item.similar.descricao,
      'percentual-demanda': item.porcentagemDemanda,
      'data-inicio': item.dataInicio
        ? format(new Date(item.dataInicio), 'dd/MM/yyyy')
        : '',
      'data-fim': item.dataFim
        ? format(new Date(item.dataFim), 'dd/MM/yyyy')
        : '',
      usuario: item.usuario ? item.usuario : '',
      criado:
        item.criadoEm != null
          ? format(new Date(item.criadoEm), 'dd/MM/yyyy HH:mm:ss')
          : ''
    })
  }

  return res
}

export const parseParametrizatioMinimumBillingData = (data: any[]): any[] => {
  const res = []
  for (const item of data) {
    res.push({
      'id-id': item.id,
      'empresa-id': item.idEmpresa,
      'empresa-nome': item.empresa ? item.empresa.descricao : '',
      'fornecedor-id': item.idFornecedor,
      'fornecedor-nome': item.fornecedor ? item.fornecedor.descricao : '',
      'faturamento-valor': parseCurrency({
        value: item.faturamentoMinimo,
        country: 'pt-br'
      })
    })
  }

  return res
}
export const parseParametrizatioIncrementSupplierData = (
  data: any[]
): any[] => {
  const res = []
  for (const item of data) {
    res.push({
      'id-id': item.id,
      'loja-id': item.lojaId,
      'loja-nome': item.lojaDescricao,
      'produto-id': item.produtoId,
      'produto-nome': item.produtoDescricao,
      'data-inicio': format(new Date(item.dataInicio), 'dd/MM/yyyy'),
      'data-fim': format(new Date(item.dataFim), 'dd/MM/yyyy'),
      obersevation: item.observacao ? item.observacao : '',
      'incremento-estoque-dias':
        item?.estoqueDias && item?.estoqueDias !== null ? item.estoqueDias : '',
      'incremento-estoque':
        item?.incrementoEstoque && item?.incrementoEstoque !== null
          ? item.incrementoEstoque
          : '',
      usuario: item.usuario,
      criado:
        item.criadoEm != null
          ? format(new Date(item.criadoEm), 'dd/MM/yyyy HH:mm:ss')
          : ''
    })
  }

  return res
}

export const parseParametrizationSettingsData = (data: any[]): any[] => {
  const res = []
  for (const item of data) {
    res.push({
      'id-id': item.idPerfil,
      'perfil-nome': item.nomePerfil,
      'param-1': item.parametros.includes(1) ? 'Sim' : 'Nao',
      'param-2': item.parametros.includes(2) ? 'Sim' : 'Nao',
      'param-3': item.parametros.includes(3) ? 'Sim' : 'Nao',
      'param-4': item.parametros.includes(4) ? 'Sim' : 'Nao',
      'param-5': item.parametros.includes(5) ? 'Sim' : 'Nao',
      'param-6': item.parametros.includes(6) ? 'Sim' : 'Nao',
      'param-7': item.parametros.includes(7) ? 'Sim' : 'Nao',
      'param-8': item.parametros.includes(8) ? 'Sim' : 'Nao',
      'param-9': item.parametros.includes(9) ? 'Sim' : 'Nao',
      'param-10': item.parametros.includes(10) ? 'Sim' : 'Nao',
      'param-11': item.parametros.includes(11) ? 'Sim' : 'Nao',
      'param-12': item.parametros.includes(12) ? 'Sim' : 'Nao',
      'param-13': item.parametros.includes(13) ? 'Sim' : 'Nao',
      'param-14': item.parametros.includes(14) ? 'Sim' : 'Nao',
      'param-15': item.parametros.includes(15) ? 'Sim' : 'Nao',
      'param-16': item.parametros.includes(16) ? 'Sim' : 'Nao',
      'param-18': item.parametros.includes(18) ? 'Sim' : 'Nao'
    })
  }

  return res
}
